import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import { windUpliftSchema } from "../../components/common/validations/Validation";
import TextField from "../../components/common/formInput/TextField";
import { options, message } from "../../components/common/utils/message";
import { alert, confirm } from "react-bootstrap-confirmation";
import { useLocation, useNavigate } from "react-router-dom";
import { failed, success } from "../../components/common/Toastify";
import queryString from 'query-string';
import { useDispatch } from "react-redux";
import TextArea from "../../components/common/formInput/TextArea";
import { addWindUplift, listWindUplift, updateWindUplift } from "../../services/windUplift";

const WindUpliftForm = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    const [resPayload, setResPayload] = useState();

    useEffect(() => {
        listWindUplift({ page: 1 }, (data) => { setResPayload(data) }, dispatch);
    }, []);

    const wind_uplift_id = queryString.parse(location.search)
    const get_wind_uplift = resPayload && resPayload.docs.find((item) => item._id === wind_uplift_id.id)

    const initialData = {
        _id: get_wind_uplift ? get_wind_uplift._id : "",
        wind_uplift_name: get_wind_uplift ? get_wind_uplift.wind_uplift_name : "",
        description: get_wind_uplift ? get_wind_uplift.description : "",
    };

    /**
     * @description Function is for add Owner.
     * @param {object} data 
     */
    const _submitData = (data) => {
        try {
            addWindUplift(data, result => {
                if (result.status === "SUCCESS" && result.code === 200) {
                    success(result.message)
                    navigate("/wind-uplift-list")
                } else if (result.status === "ERROR" && result.code === 403) {
                    failed(result.message)
                }
            }, dispatch)
        } catch (e) {
            failed(e)
        }
    };

    /**
     * @description Function is for Update Owner with building.
     * @param {object} data 
     */
    const _updateData = async (data) => {
        try {
            updateWindUplift(data, result => {
                if (result.status === "SUCCESS" && result.code === 200) {
                    success(result.message);
                    navigate("/wind-uplift-list")
                } else if (result.status === "ERROR" && result.code === 403) {
                    failed(result.message)
                }
            }, dispatch)
        } catch (e) {
            failed(e)
        }
    };

    /**
     * @description Function is For on Cancel Confirm Box.
     */
    const onCancel = async () => {
        const result = await confirm(message.cancelWindUplift, options);
        if (result) {
            alert(message.canceledWindUpliftForm);
            navigate("/wind-uplift-list");
        }
    };

    return (
        <div className="dashboard-inner p-b-0">
            <Formik
                initialValues={initialData}
                enableReinitialize
                validationSchema={windUpliftSchema}
                onSubmit={(values) => get_wind_uplift ? _updateData(values) : _submitData(values)}
            >
                {(formik) => (
                    <Form>
                        <div className="d-card m-b-25">
                            <div className="d-card-header">
                                <h5 className="d-card-heading">Add Wind Uplift Requirement</h5>
                            </div>
                            <div className="d-card-body p-b-0">
                                <div className="form-content">
                                    <div className="f-row alignTop">
                                        <div className="f-33">
                                            <TextField
                                                label="Wind Uplift Name"
                                                name="wind_uplift_name"
                                                value={formik?.values?.wind_uplift_name}
                                                onChange={formik.handleChange}
                                                required={true}
                                            />
                                        </div>
                                    </div>
                                    <div className="f-row alignTop">
                                        <div className="f-66">
                                            <TextArea
                                                label="Wind_uplift Description"
                                                name="description"
                                                value={formik?.values?.description}
                                                onChange={formik.handleChange}
                                                required={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="d-card-bottom">
                            <div className="d-card-bottom-cell">
                                <button className="btn btn-blue" type="submit">{get_wind_uplift ? "Edit Wind_uplift" : "Add Wind_uplift"}</button>
                            </div>
                            <div className="d-card-bottom-cell">
                                <button className="btn btn-grey" onClick={onCancel} type="button">
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default WindUpliftForm;
